import { render, staticRenderFns } from "./DxPostWorkAttachmentMachinaryTable.vue?vue&type=template&id=389b3494&"
import script from "./DxPostWorkAttachmentMachinaryTable.vue?vue&type=script&lang=js&"
export * from "./DxPostWorkAttachmentMachinaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports